import {LOGS_REQUEST, LOGS_SUCCESS, LOGS_EMPTY, LOGS_ERROR} from '@/store/actions/logs'
import Api from '@/services/Api'

const state = {
  status: '',
  logs: []
};


const getters = {
    getLogs: state => state.logs,
};

const actions = {
  [LOGS_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(LOGS_REQUEST)

      Api().get('/logs')
      .then(function (response) {
        commit(LOGS_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(LOGS_ERROR);
        reject(error);
      });
    });
  }
};

const mutations = {
  [LOGS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [LOGS_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [LOGS_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [LOGS_ERROR]: (state) => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
}
